import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const HoverableCardsSectionContainer = styled.div`
  max-width: 100vw !important;
  background-color: ${palette.wheat};
`;

export const HoverableCardsSectionContent = styled.div`
  max-width: 1248px;
  margin: 0 auto;
  padding: 6rem 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 3rem;

  > h1 {
    max-width: 845px;
    margin: 0 auto;
  }

  > p {
    max-width: 748px;
    margin: 0 auto;
  }

  .hoverable-selector-container {
    max-width: 1150px;

    @media screen and (max-width: ${layout.lg}) {
      max-width: 100%;

      p {
        white-space: nowrap;
      }
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    padding: 3rem 1.5rem;
    row-gap: 2.5rem;
  }
`;

export const ItemsContainer = styled.div`
  position: relative;
`;

export const ArrowsContainer = styled.div`
  justify-content: center;
  align-items: center;
  column-gap: 2.25rem;
  width: 100%;
  display: none;

  @media screen and (max-width: ${layout.sm}) {
    display: flex;
  }
`;

interface ArrowButtonProps {
  orientation: 'left' | 'right';
}

export const ArrowButton = styled.button<ArrowButtonProps>`
  outline: none;
  border: none;
  background-color: transparent;
  cursor: pointer;

  transform: ${(props) => (props.orientation === 'left' ? 'rotate(180deg)' : 'none')};
`;
